import Logger from '../../../Common/Utils/Logger'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'

export class ReportsDatabase {
  constructor() {
    this.db = null
  }

  open() {
    return new Promise((resolve, reject) => {
      const request = window.indexedDB.open('LocalReports', 1)
      request.onerror = (e) => {
        Logger.error('Access IndexedDb error', e)
        reject(e)
      }
      request.onsuccess = (e) => {
        Logger.debug('IndexedDb connection success', e)
        this.db = request.result
        resolve()
      }
      request.onupgradeneeded = (e) => {
        Logger.info('IndexedDb database created/updated', e)
        console.info('Database created')
        const db = request.result

        const objectStore = db.createObjectStore('reports', { keyPath: 'id' })
        objectStore.createIndex('id', 'id', { unique: true })
        objectStore.createIndex('name', 'name', { unique: false })
        objectStore.createIndex('updated', 'updated', { unique: false })
        objectStore.createIndex('items', 'items', { unique: false })

        // Transaction completed
        objectStore.transaction.oncompleted = (e) => {
          Logger.info('Object store "report" created', e)
        }
        resolve()
      }
    })
  }

  getAll() {
    return new Promise((resolve, reject) => {
      const request = this.db
        .transaction('reports')
        .objectStore('reports')
        .getAll()

      request.onsuccess = () => {
        const reports = request.result
        return resolve(reports)
      }

      request.onerror = (err) => {
        Logger.error(`Error to get all reports: ${err}`)
        reject(err)
      }
    })
  }

  getReport(id) {
    return new Promise((resolve, reject) => {
      const request = this.db
        .transaction('reports')
        .objectStore('reports')
        .get(id)

      request.onsuccess = () => {
        const report = request.result
        resolve(report)
      }

      request.onerror = (err) => {
        Logger.error(`Error to get report: ${err}`)
        reject(err)
      }
    })
  }

  addReport(report) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction('reports', 'readwrite')

      const objectStore = transaction.objectStore('reports')

      // Add new student
      const request = objectStore.add({
        ...report,
        id: uuidv4(),
        updated: moment().valueOf(),
      })

      request.onsuccess = () => {
        Logger.debug('New report added', request.result)
        resolve()
      }

      request.onerror = (err) => {
        Logger.error(`Error to add new report: ${err}`)
        reject(err)
      }
    })
  }

  addReportItem(id, item) {
    return new Promise((resolve, reject) => {
      const objectStore = this.db
        .transaction('reports', 'readwrite')
        .objectStore('reports')

      const request = objectStore.get(id)

      request.onsuccess = () => {
        const report = request.result
        report.items = [...report.items, item]
        const updateRequest = objectStore.put(report)

        updateRequest.onsuccess = () => {
          resolve(updateRequest.result)
        }
      }

      request.onerror = (err) => {
        Logger.error(`Error to add new item to report: ${err}`)
        reject(err)
      }
    })
  }

  deleteReport(id) {
    return new Promise((resolve, reject) => {
      const request = this.db
        .transaction('reports', 'readwrite')
        .objectStore('reports')
        .delete(id)

      request.onsuccess = () => {
        resolve(request.result)
      }

      request.onerror = (err) => {
        Logger.error(`Error to delete report: ${err}`)
        reject(err)
      }
    })
  }
}
